module.exports = __webpack_public_path__ + "static/img/zhaopin_1.d924dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/zhaopin_1.png
// module id = z7w2
// module chunks = 1